import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen'
import { limitFit } from '@cloudinary/url-gen/actions/resize'

const cloudinary = new Cloudinary({
  cloud: {
    cloudName: 'zoi-prod'
  },
  url: {
    // Disable dynamic URL parameter generation to ensure consistency between server and client rendering
    analytics: false
  }
})

export const getMediaURL = (publicID: CloudinaryImage['publicID']) => {
  return cloudinary.image(publicID).toURL()
}

export const getImageURL = ({
  id,
  fit,
  quality = 'auto',
  format = 'auto'
}: {
  id: CloudinaryImage['publicID']
  fit?: { width: number; height: number }
  quality?: string
  format?: string
}) => {
  const image = cloudinary.image(id)

  if (fit) {
    image.resize(limitFit().height(fit.height).width(fit.width))
  }

  return image.quality(quality).format(format).toURL()
}
